/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_Generic_LabelInputs */

const en_us2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workout`)
};

const pt_br2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um treino`)
};

const es_419_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un entrenamiento`)
};

const pt_pt2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um treino`)
};

const fr_fr2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séance`)
};

const de_de2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Training`)
};

const it_it2_workout_open_generic_label = /** @type {(inputs: Workout_Open_Generic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un allenamento`)
};

/**
* | output |
* | --- |
* | "A workout" |
*
* @param {Workout_Open_Generic_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_generic_label = /** @type {((inputs?: Workout_Open_Generic_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_Generic_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_generic_label(inputs)
	if (locale === "es-419") return es_419_workout_open_generic_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_generic_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_generic_label(inputs)
	if (locale === "de-DE") return de_de2_workout_open_generic_label(inputs)
	if (locale === "it-IT") return it_it2_workout_open_generic_label(inputs)
	return en_us2_workout_open_generic_label(inputs)
});
export { workout_open_generic_label as "workout.open_generic_label" }